module.exports = __webpack_public_path__ + "img/portrait.6d1d28be.jpg";